import React, { Component } from 'react';
import { Input, Select, Icon, Button, Typography } from 'antd';
const { Title, Paragraph, Text } = Typography;

const { Option } = Select;

class Settings extends Component {

  state = {
    dataEndPoint: 'gobblerai.com/api/links/review',
    imgEndPoint1: 'gobblerai.com',
    imgEndPoint2: '/api',
    imgEndPoint3: '/imageReview',
    imgEndPoint4: '/${classifiedData.winner}',
    imgEndPoint5: '/${companyId}',
    imgEndPoint6: '/${id}',
    saveEndPoint1: 'gobblerai.com',
    saveEndPoint2: '/api',
    saveEndPoint3: '/links',
    saveEndPoint4: '/review',
    saveEndPoint5: '/${_id}',
    saveEndPoint6: '',
  }

  saveUserEndpoints = () => { 
    let imgEndPoint = this.state.imgEndPoint1 + this.state.imgEndPoint2 + this.state.imgEndPoint3 + this.state.imgEndPoint4 + this.state.imgEndPoint5 + this.state.imgEndPoint6
    let saveEndPoint = this.state.saveEndPoint1 + this.state.saveEndPoint2 + this.state.saveEndPoint3 + this.state.saveEndPoint4 + this.state.saveEndPoint5 + this.state.saveEndPoint6

    let endpoints = {
      dataEndPoint: 'https://' + this.state.dataEndPoint,
      imgEndPoint: 'https://' + imgEndPoint,
      saveEndPoint: 'https://' + saveEndPoint,
    }

    this.props.updateSettings(endpoints)
  }

  handleChange = (endPoint, e) => {
    this.setState({
      [endPoint]: e.target.value
    })
  }

  render() {
    return (
      <div>
        <Title>Enter / Edit Endpoints</Title>
        <Paragraph>
          Provide us endpoints that we can call to display your data.
        </Paragraph>
        <br />
        <div>
          <div style={{ marginBottom: 16 }}>
            <p>API Endpoint to Get a List of Data</p>
            <Input addonBefore="Https://" value={this.state.dataEndPoint} onChange={(e) => this.handleChange('dataEndPoint', e)}  defaultValue="mysite" />
          </div>
          <br />
          <p>API Endpoint to Get Each Image from "Result" Above</p>
          <div style={{ marginBottom: 16, display: 'flex', flexDirection: 'column'}}>
            <Input addonBefore="Https://" value={this.state.imgEndPoint1} onChange={(e) => this.handleChange('imgEndPoint1', e)} />
            <Input style={{marginLeft: 'auto', width: '90%'}} value={this.state.imgEndPoint2} onChange={(e) => this.handleChange('imgEndPoint2', e)} />
            <Input style={{marginLeft: 'auto', width: '90%'}} value={this.state.imgEndPoint3} onChange={(e) => this.handleChange('imgEndPoint3', e)} />
            <Input style={{marginLeft: 'auto', width: '90%'}} value={this.state.imgEndPoint4} onChange={(e) => this.handleChange('imgEndPoint4', e)}/>
            <Input style={{marginLeft: 'auto', width: '90%'}} value={this.state.imgEndPoint5} onChange={(e) => this.handleChange('imgEndPoint5', e)} />
            <Input style={{marginLeft: 'auto', width: '90%'}} value={this.state.imgEndPoint6} onChange={(e) => this.handleChange('imgEndPoint6', e)} />
          </div>
          <br />
          <div style={{ marginBottom: 16 }}>
            <p>API Endpoint to Save Updated Data + Predictions</p>    
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <Input addonBefore="Https://" value={this.state.saveEndPoint1} onChange={(e) => this.handleChange('saveEndPoint1', e)} />
              <Input style={{marginLeft: 'auto', width: '90%'}} value={this.state.saveEndPoint2} onChange={(e) => this.handleChange('saveEndPoint2', e)} />
              <Input style={{marginLeft: 'auto', width: '90%'}} value={this.state.saveEndPoint3} onChange={(e) => this.handleChange('saveEndPoint3', e)} />
              <Input style={{marginLeft: 'auto', width: '90%'}} value={this.state.saveEndPoint4} onChange={(e) => this.handleChange('saveEndPoint4', e)} />
              <Input style={{marginLeft: 'auto', width: '90%'}} value={this.state.saveEndPoint5} onChange={(e) => this.handleChange('saveEndPoint5', e)} />
              <Input style={{marginLeft: 'auto', width: '90%'}} value={this.state.saveEndPoint6} onChange={(e) => this.handleChange('saveEndPoint6', e)} />
            </div>
          </div>

        </div>
        <br />
        <Button type="primary" onClick={() => this.saveUserEndpoints()}>Save</Button>
      </div>
    );
  }
}

export default Settings;